import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    /* Listas de seleccion */
    usuariosRolesList: [],
    usuariosRolesSelectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_LIST'(state) {
        state.usuariosRolesList = [];
        state.usuariosRolesSelectList = [];
    },
    'SET_LIST'(state, params) {
        state.usuariosRolesList = params.usuariosRolesList;
        state.usuariosRolesSelectList = params.usuariosRolesSelectList;
    },
};

const actions = {
    getUsuariosRolesList: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('usuariosroles/list')
                .then(res => {
                    var list = [];
                    for(let key in res.data) {
                        const item = res.data[key]
                        list.push(item.nombre.trim())
                    } 
                    var params = {
                        usuariosRolesList: res.data,
                        usuariosRolesSelectList: list
                    }
                    commit('SET_LIST', params);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }, error => {
                reject(error);
            })
    },
};

const getters = {
    getField,

    usuariosRolesList (state) {
        return state.usuariosRolesList;
    },
    usuariosRolesSelectList (state) {
        return state.usuariosRolesSelectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}